import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'

/**
 * No QueryClientProvider here.
 *
 * React Query is used by the survey and by nothing else — NodeScreen, useSurvey
 * and the bootstrap in SurveyApp — so the provider lives inside the lazily
 * loaded survey chunk. Mounting it at the root would pull the library into the
 * marketing landing page's critical path for no reason.
 */
createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</StrictMode>
)
